import React, { useState, useEffect } from "react";
import { AuthApi, ApiClient } from "./tradingApiSdk/src";
import Form from "@cloudscape-design/components/form";
import FormField from "@cloudscape-design/components/form-field";
import Button from "@cloudscape-design/components/button";
import Input from "@cloudscape-design/components/input";
import Container from "@cloudscape-design/components/container";
import Header from "@cloudscape-design/components/header";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { useNavigate } from "react-router-dom";

function detectApiBaseUrl() {
  const hostname = window.location.hostname;
  if (hostname.includes("beta")) {
    return "https://beta-api.edge.a1ultra.com";
  } else if (hostname.includes("127.0.0.1")) {
    return "http://127.0.0.1:5000";
  } else {
    return "https://api.edge.a1ultra.com";
  }
}

export default function LoginPage({ onLoginSuccess }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    async function checkStatus() {
      try {
        const client = new ApiClient();
        client.enableCookies = true;
        client.fetchOptions = { credentials: "include", cache: "no-cache" };

        const res = await fetch(`${client.basePath}/auth/status`, {
          credentials: "include",
          cache: "no-cache",
        });
        const data = await res.json();

        if (data.logged_in) {
          onLoginSuccess(); // ✅ Updates state in `App.js`
          navigate("/", { replace: true }); // ✅ Redirects to home
        }
      } catch (err) {
        console.error("Status check error:", err);
      }
    }
    checkStatus();
  }, [navigate, onLoginSuccess]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMsg("");

    try {
      const client = new ApiClient();
      client.basePath = detectApiBaseUrl();
      client.enableCookies = true;
      client.fetchOptions = { credentials: "include" };

      const authApi = new AuthApi(client);
      await authApi.postLoginResource({ username, password });

      onLoginSuccess(); // ✅ Updates React state
      navigate("/", { replace: true }); // ✅ Redirects to homepage
    } catch (err) {
      console.error("Login error:", err);
      setErrorMsg("Login failed. Check credentials or server logs.");
    }
  };

  return (
    <Container
      header={<Header variant="h2" description="Please enter your credentials">Login</Header>}
    >
      <form onSubmit={handleSubmit}>
        <SpaceBetween size="m">
          <Form errorText={errorMsg} actions={<Button variant="primary" formAction="submit">Login</Button>}>
            <FormField label="Username">
              <Input value={username} onChange={(e) => setUsername(e.detail.value)} placeholder="Enter username" />
            </FormField>
            <FormField label="Password">
              <Input type="password" value={password} onChange={(e) => setPassword(e.detail.value)} placeholder="Enter password" />
            </FormField>
          </Form>
        </SpaceBetween>
      </form>
    </Container>
  );
}